// extracted by mini-css-extract-plugin
export default {"Container":"Tooltip_Container__ECLVW","Main":"Tooltip_Main__HVYB7","ImageWrapper":"Tooltip_ImageWrapper__amX5w","TextWrapper":"Tooltip_TextWrapper__cZycV"};